<!--  -->
<template>
  <div class="traffic-main">
    <div id="monthUseWaterChart" style="height: 100%; width: 98%"></div>
  </div>
</template>

<script>
import charts from "echarts";
import API from "../api/index";
export default {
  props: {
    title: {
      type: String,
      default: "用水趋势",
    },
  },
  data() {
    return {
      monthUseWaterChart: null,
      monthUseWaterChartOption: {},
      xAxisData: [],
      yAxisData1: [],
    };
  },

  components: {},

  // computed() {},

  mounted() {
    var self = this;

    self.monthUseWaterChart = charts.init(
      document.getElementById("monthUseWaterChart")
    );
    self.queryData().then((res) => {
      self.initPowerChart();
    });
  },

  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.energy.queryWaterRecord).then((res) => {
          if (res.success) {
            res.returnObj.forEach((el) => {
              this.xAxisData.push(el.date);
              this.yAxisData1.push(el.waterValue);
              // this.yData[1].push(el.personnelOutCount);
            });
            resolve({ xData: this.xAxisData, yData: this.yAxisData1 });
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    initPowerChart() {
      const color = ["#02ECFF", "#E8395D"];

      //   const yAxisData2 = [233, 200, 180, 199, 233, 210, 180];
      const option = {
        color: color,
        // title: {
        //   text: this.title,
        //   textStyle: {
        //     color: "#FFFFFF",
        //     fontSize: 15,
        //   },
        //   left: "55",
        //   top: "0",
        // },
        legend: {
          icon: "rect",
          itemHeight: 4,
          itemWidth: 10,
          textStyle: {
            color: "#ffffff",
          },
          right: 10,
          top: 10,
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 0,
          bottom: 0,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            name: "月",
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#E4F5FD",
              },
            },
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：吨",
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 12,
              lineHeight: 40,
              padding: [0, 0, 0, 50]
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "用水趋势",
            type: "line",
            smooth: true,
            symbol: "none",

            symbolSize: 10,
            lineStyle: {
              normal: {
                color: color[0],
                width: 2,
              },
            },
            areaStyle: {
              color: new charts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(27, 235, 242, 0)",
                },
                {
                  offset: 1,
                  color: "#343740",
                },
              ]),
            },
            data: this.yAxisData1,
          },
          //   {
          //     name: "出园",
          //     type: "line",
          //     smooth: true,
          //     symbolSize: 10,
          //     lineStyle: {
          //       normal: {
          //         color: color[1],
          //         width: 2,
          //       },
          //     },
          //     data: yAxisData2,
          //   },
        ],
      };
      this.monthUseWaterChart = charts.init(
        document.getElementById("monthUseWaterChart")
      );
      this.monthUseWaterChart.setOption(option);
    },
  },
};
</script>
<style lang='scss' scoped>
.traffic-main {
  height: 100%;
}
</style>